import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Select from "react-select";
import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
import axios from "../api/axios";
import FindModuleById from '../FindModuleById';
import { useFormik, FormikProvider } from "formik";
import { Apitoken, Authtoken } from '../Global';
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import $ from "jquery";
const QualityConsumableAdd = () => {
  const [backendErrors, setBackendErrors] = useState([]);
   const [permission, setPermission] = useState({});
 
  const [consumablessection, setConsumablessection] = useState([]);
  const [menu, setMenu] = useState(false);


  const formik = useFormik({
    initialValues: {
      consumable_name: "",
      description: "",
      supplier: "",
      critical_level: "",
      section:'',
      average_level: "",
      supplierarr: [],

    },
    onSubmit: (values,{ setSubmitting }) => {
      axios
        .post("/quality-consumables/add", values, {
          headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
        })
        .then((response) => {
        
          delete backendErrors['error'];
          setSubmitting(false);
          $("#form-submit").text("Add Consumable");
          if (response.data.code === 200) {
            toast.success(response.data.message);
            setTimeout(() => {
              window.location.href = "/quality-consumables";
            }, 1000);
          }  else if (response.data.code === 422) {
              setBackendErrors(response.data.error);
          }
          else if (response.data.code === 401) {
            setBackendErrors(response.data.error);
          }
          else {
             setBackendErrors(response.data.error);
          }
        })
        .catch((error) => {
          console.log(error);
          // actions.setSubmitting(false);
        });
    },
  });

  const toggleMobileMenu = () => {
    setMenu(!menu);
  };

   
  useEffect(() => {
    setPermission(FindModuleById(457)); 

       

         axios
      .get("/helpers/quality-consumables-sections", {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      })
      .then((response) => {
        if (response.data.code === 200) {
          let supplier_types = response.data.data.types;
          // setPackagingTypesLists(materials_payment_status);
          let supplier_typesList = supplier_types.map((ord, index) => ({
            label: ord.title,
            value: ord.id,
            key: `supplier-${index}`,
          }));
          setConsumablessection(supplier_typesList);
        } else {
          console.log("API response is not an array");
        }
      })
      .catch((error) => {
        console.log(error);
      });

}, []);
const customHandleInput = (event) => {
  const Input_name = event.target.name;
  delete backendErrors[Input_name];
};

const handleSelectChange = (name, selectedOption) => {
    const value = selectedOption ? selectedOption.value : "";
    updateFormikValue(name, value);
    customHandleInput({ target: { name, value } });
  };
  
  const updateFormikValue = (name, value) => {
    formik.setFieldValue(name, value);
  };
  return (
    <>
      <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={() => toggleMobileMenu()} />
        <Sidebar />
        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="page-header">
              <div className="row">
                <div className="col-sm-12">
                  <h3 className="page-title">Quality Consumables</h3>
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/profile">Profile</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="/quality-consumables">Quality Consumables</Link>
                    </li>
                    <li className="breadcrumb-item active">Add Quality Consumable</li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                    <h4 className="card-title">Consumable Information</h4>
                    {permission && permission.add == 1 && (
                    <FormikProvider value={formik}>
                    <form action="#" onSubmit={formik.handleSubmit}>
                     
                     <div className="row">
                       <div className="col-md-6">
                         <div className="form-group">
                           <label> Consumable Name</label>
                           <input
                             type="text"
                             name="consumable_name"
                             value={formik.values.consumable_name}
                             className={
                               backendErrors.consumable_name
                                 ? "form-input form-control input-error"
                                 : "form-input form-control"
                             }
                          
                             onChange={(e) => {
                                formik.handleChange(e);
                               customHandleInput(e);
                             }}
                              onBlur={formik.handleBlur}
                           />
                          <small>
                             {backendErrors.consumable_name && (
                               <span className="form-error mt-1">
                                 {backendErrors.consumable_name}
                               </span>
                             )}
                           </small>
                         </div>
                       
                       </div>
                       <div className="col-md-3">
                         <div className="form-group">
                           <label> Critical Level</label>
                           <input
                             type="text"
                             onKeyPress={(event) => {
                               // Allow only numbers (0-9)
                               if (!/^[0-9]$/.test(event.key)) {
                               event.preventDefault();
                               }
                             }}
                             name="critical_level"
                             value={formik.values.critical_level}
                             className= "form-input form-control"
                               onChange={(e) => {
                                formik.handleChange(e);
                               customHandleInput(e);
                             }}
                              onBlur={formik.handleBlur}
                           />
                          <small>
                             {backendErrors.critical_level && (
                               <span className="form-error mt-1">
                                 {backendErrors.critical_level}
                               </span>
                             )}
                           </small>
                         </div>
                       
                       </div>
                       <div className="col-md-3">
                         <div className="form-group">
                           <label> Average Level</label>
                           <input
                             type="text"
                             onKeyPress={(event) => {
                               // Allow only numbers (0-9)
                               if (!/^[0-9]$/.test(event.key)) {
                               event.preventDefault();
                               }
                             }}
                             name="average_level"
                             value={formik.values.average_level}
                             className= "form-input form-control"
                               onChange={(e) => {
                                formik.handleChange(e);
                               customHandleInput(e);
                             }}
                              onBlur={formik.handleBlur}
                           />
                          <small>
                             {backendErrors.average_level && (
                               <span className="form-error mt-1">
                                 {backendErrors.average_level}
                               </span>
                             )}
                           </small>
                         </div>
                       
                       </div>
                        <div className="col-md-4">
                         <div className="form-group status">
                           <label>Section</label>
                                 <Select
                                 className="w-100"
                                 value={consumablessection.find(option => option.value == formik.values.section) || null} // Ensure correct format
                                 name="section"
                                 onChange={(selectedOption) => {
                                 handleSelectChange("section", selectedOption);
                               //   generateLotNumberLocation(selectedOption.value);
                                 }}
                                 onBlur={formik.handleBlur}
                                 options={consumablessection}
                                 placeholder="Select"

                              
                                 />
                          
                          
                         <small>
                             {backendErrors.section  && (
                               <span className="form-error mt-1">
                                 {backendErrors.section}
                               </span>
                             )}
                           </small>
                         </div>
                       </div>
                       <div className="col-md-8">
                         <div className="form-group">
                           <label>description</label>
                           <input
                             type="text"
                             name="description"
                             value={formik.values.description}
                             className={
                               backendErrors.description
                                 ? "form-input form-control input-error"
                                 : "form-input form-control"
                             }
                             onChange={(e) => {
                                formik.handleChange(e);
                               customHandleInput(e);
                             }}
                               onBlur={formik.handleBlur}
                           />
                           <small>
                             {backendErrors.description && (
                               <span className="form-error mt-1">
                                 {backendErrors.description}
                               </span>
                             )}
                           </small>
                         </div>
                         </div>
                       
                     
                     </div>



                     <small>
                             {backendErrors.status  && (
                               <span className="form-error mt-1">
                                 {backendErrors.status}
                               </span>
                             )}

                           </small>
                     <div className="text-end mt-4">
                       <button
                         type="submit" id="form-submit"
                         className="btn btn-primary"
                         disabled={formik.isSubmitting}
                       >
                         Add Consumable
                       </button>
                     </div>
                   </form>
                    </FormikProvider>

                    )}
                    
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default QualityConsumableAdd;
